export default __webpack_public_path__ + "static/ailin2-e6125788ea9b7ccd8a7aa8e60f008fff.png";